<template>
  <!-- 選択可能な言語が1つだけのテナントではメニュー自体を出さない -->
  <v-menu offset-y v-if="languageList.length > 1">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" color="indigo-darken-1">
        <v-icon size="large" color="white">mdi-translate</v-icon>
      </v-btn>
    </template>
    <v-list density="compact">
      <!-- 選択可能な言語を列挙 -->
      <template v-for="lang in languageList" :key=lang>
        <v-list-item @click.stop="changeLanguage(lang)">
          <v-list-item-title>{{ $t(`common.label.language.${lang}`) }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="js">
import store from '@/store/index';

/**
 * 言語選択コンポーネント
 */
export default {
  computed: {
    /** 選択可能な言語コードリストを返却する */
    languageList() {
      return this.getLanguageList();
    },
  },
  methods: {
    /**
     * 言語を変更する
     * @param lang 言語コード
     */
    changeLanguage(lang) {
      const newLang = this.determineLanguage(lang);
      store.setLanguage(newLang);
      location.reload();
    },
    /**
     * 適用する言語コードを決定する \
     * 適用したい言語コードが選択不可である場合、選択可能な言語コードのうち、先頭のものを適用する。
     * @param lang 適用したい言語コード
     * @return 適用する言語コード
     */
    determineLanguage(lang) {
      const langList = this.getLanguageList();
      if (langList.indexOf(lang) == -1) return langList[0]
      return lang;
    },
    /**
     * 選択可能な言語コードリストを返却する
     */
    getLanguageList() {
      return process.env.VUE_APP_LANGUAGE_SET.split(',');
    }
  },
  mounted() {
    // セッションに格納されている言語コードを適用する
    this.$i18n.locale = this.determineLanguage(store.getLanguage());
  },
};
</script>
